import Swiper from "swiper";
import { Navigation, Pagination, EffectFade } from "swiper/modules";

import { $qs, $qsa } from "../../../src/js/utils/querySelector";

function textWithQuote() {
	const textWithQuoteSwipers = $qsa('[data-name="text-with-quote-swiper"]');

	if (textWithQuoteSwipers.length > 0) {
		// Starting point
		textWithQuoteSwipers.forEach((textWithQuoteSwiper) => {
			function initializeSwiper() {
				let swiper = new Swiper(textWithQuoteSwiper, {
					modules: [Navigation, Pagination, EffectFade],
					effect: "fade",
					fadeEffect: { crossFade: true },
					slidesPerView: 1,
					spaceBetween: 0,
					speed: 1000,
					pagination: {
						el: $qs(".swiper-pagination", textWithQuoteSwiper),
						clickable: true,
					},
				});
			}

			initializeSwiper();

			// Also re-initialize when the window is resized
			window.addEventListener("resize", initializeSwiper);
		});
	}
}

export default textWithQuote;
